import { render, staticRenderFns } from "./ApproveBookingAction.vue?vue&type=template&id=fa805f30&"
import script from "./ApproveBookingAction.vue?vue&type=script&lang=js&"
export * from "./ApproveBookingAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports